import { useState, useCallback } from 'react';

const useReplyModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [originalPost, setOriginalPost] = useState(null);
  const [parentReplyId, setParentReplyId] = useState(null);

  const openModal = useCallback((post, replyId = null) => {
    setOriginalPost(post);
    setParentReplyId(replyId);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setOriginalPost(null);
    setParentReplyId(null);
  }, []);

  return {
    isOpen,
    originalPost,
    parentReplyId,
    openModal,
    closeModal
  };
};

export default useReplyModal;